import { Users, Award, Briefcase, Newspaper, Stethoscope, Search, Truck, Package } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const OrganigrammaPage = () => {
  const organigramma = [
    {
      section: "Direzione",
      icon: Award,
      members: [
        { role: "Presidente", name: "Massimo Gariglio" },
        { role: "Vicepresidente", name: "Enzo Rolle" },
        { role: "Presidente Onorario", name: "Libero Tubino" },
        { role: "Presidente SGS", name: "Vincenzo Caccuri" },
      ],
    },
    {
      section: "Area Sportiva",
      icon: Briefcase,
      members: [
        { role: "Direttore Sportivo Prima Squadra", name: "Tommaso Gallo" },
        { role: "Direttore Sportivo SGS", name: "Lorenzo De Simone" },
        { role: "Responsabile Attività di Base", name: "Nicola Di Biase" },
        { role: "Coordinatori Attività di Base", name: "Andrea Mirasola, Davide De Letteriis" },
      ],
    },
    {
      section: "Segreteria",
      icon: Users,
      members: [
        { role: "Segretario Generale", name: "Enzo De Benedittis" },
        { role: "Segretari", name: "Emilio De Cicco, Luca Scanavino, Claudia Rofi, Pietro Miroglio" },
      ],
    },
    {
      section: "Comunicazione",
      icon: Newspaper,
      members: [
        { role: "Ufficio Stampa e Social Media", name: "Giulia Lamensa" },
      ],
    },
    {
      section: "Area Medica",
      icon: Stethoscope,
      members: [
        { role: "Medico Sociale", name: "Giulio Meinardi" },
      ],
    },
    {
      section: "Scouting",
      icon: Search,
      members: [
        { role: "Area Scouting", name: "Massimo Lopalco, Cristian Guastaferri" },
      ],
    },
    {
      section: "Logistica",
      icon: Package,
      members: [
        { role: "Magazzino", name: "Aldo Marcone, Stefano Breda" },
        { role: "Autisti", name: "Gianni Gardellini, Gerardo Monaco" },
      ],
    },
  ];

  return (
    <div data-testid="organigramma-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-12 bg-[#0047AB] noise-overlay">
        <div className="max-w-7xl mx-auto px-4 text-center text-white">
          <h1 className="text-4xl lg:text-5xl font-black uppercase mb-4 animate-fade-in-up">
            Organigramma
          </h1>
          <p className="text-blue-200 max-w-xl mx-auto">
            La struttura dirigenziale del G.S.D. Volpiano Pianese
          </p>
        </div>
      </section>

      {/* Organigramma Content */}
      <section className="section-padding bg-slate-50">
        <div className="max-w-5xl mx-auto px-4">
          <div className="space-y-8">
            {organigramma.map((section, sectionIndex) => {
              const IconComponent = section.icon;
              return (
                <div
                  key={sectionIndex}
                  className="bg-white rounded-2xl shadow-sm overflow-hidden"
                  data-testid={`org-section-${sectionIndex}`}
                >
                  {/* Section Header */}
                  <div className="bg-gradient-to-r from-[#0047AB] to-[#003380] px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                        <IconComponent className="w-5 h-5 text-white" />
                      </div>
                      <h2 className="text-xl font-bold text-white">
                        {section.section}
                      </h2>
                    </div>
                  </div>

                  {/* Members */}
                  <div className="divide-y divide-slate-100">
                    {section.members.map((member, memberIndex) => (
                      <div
                        key={memberIndex}
                        className="px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 hover:bg-slate-50 transition-colors"
                      >
                        <span className="text-sm font-medium text-[#0047AB] uppercase tracking-wide">
                          {member.role}
                        </span>
                        <span className="text-lg font-semibold text-slate-900">
                          {member.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer Note */}
          <div className="mt-12 text-center">
            <p className="text-slate-500 text-sm">
              Società Affiliata a Juventus FC
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OrganigrammaPage;
